<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col">
        <div class="widget">
          <div class="widget-content widget-content-mini themed-background-dark-default text-light">
            <span class="float-right text-muted">
              <i class="fa fa-search"></i>
            </span>
            Consultar información de contacto
          </div>
          <div class="widget-content border-bottom themed-background-muted text-center">
            <form @submit.prevent="consultar">
              <div class="form-group row">
                <label for class="col-md-3 control-label text-right">Documento</label>
                <div class="col-md-9">
                  <input type="text" class="form-control" v-model="documento" />
                </div>
              </div>

              <div class="col-12 text-center">
                <div class="btn-group">
                  <button type="submit" :disabled="loading || documento.length < 3" class="btn btn-info">
                    Consultar
                  </button>

                  <button type="button" :disabled="loading || documento.length < 3" class="btn btn-secondary"
                    v-if="!ocultar_info" @click="consultaAmpliada">
                    Ampliar busqueda
                  </button>
                </div>
              </div>
            </form>
          </div>

        </div>
      </div>
    </div>

    <div class="row" v-if="!ocultar_info">
      <div class="col">
        <div class="row">
          <div class="loader centrado" v-if="datosConsulta.loading">
            <i class="fa fa-spinner fa-2x fa-spin text-info"></i>
          </div>
          <div class="col-md-12 col-xs-12">
            <div class="widget">
              <div class="widget-content widget-content-mini themed-background-dark-default text-light">
                <span class="float-right text-muted">
                  <i class="fa fa-book"></i>
                </span>
                Acuerdos de pago
              </div>
              <div class="widget-content border-bottom themed-background-muted text-center">
                <h3>
                  <b>En el transcurso del dia</b>
                </h3>
                <span>{{ datosConsulta.acuerdos_hoy }}</span>
                <h3>
                  <b>En el mes en curso</b>
                </h3>
                <span>{{ datosConsulta.acuerdos_mes }}</span>
              </div>
            </div>
          </div>
          <div class="col-md-12 col-xs-12">
            <div class="widget">
              <div class="widget-content widget-content-mini themed-background-dark-default text-light">
                <span class="float-right text-muted">
                  <i class="fa fa-thumbs-up"></i>
                </span>
                Gestiones realizadas
              </div>
              <div class="widget-content border-bottom themed-background-muted text-center">
                <h3>
                  <b>En el transcurso del dia</b>
                </h3>
                <span>{{ datosConsulta.gestiones_hoy }}</span>
                <h3>
                  <b>En el mes en curso</b>
                </h3>
                <span>{{ datosConsulta.gestiones_mes }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col">
        <div class="loader centrado" v-if="datosConsulta.loading">
          <i class="fa fa-spinner fa-2x fa-spin text-info"></i>
        </div>
        <div class="widget">
          <div class="widget-content widget-content-mini themed-background-dark-default text-light">
            <span class="float-right text-muted">
              <i class="fa fa-search"></i>
            </span>
            Ejecución Presupuestal Global del Mes en Curso
          </div>
          <div class="widget-content border-bottom themed-background-muted text-center">
            <bar-chart :grafica="'presupuesto_general'" />
          </div>
        </div>
      </div>

      <div class="col">
        <div class="loader centrado" v-if="datosConsulta.loading">
          <i class="fa fa-spinner fa-2x fa-spin text-info"></i>
        </div>
        <div class="widget">
          <div class="widget-content widget-content-mini themed-background-dark-default text-light">
            <span class="float-right text-muted">
              <i class="fa fa-search"></i>
            </span>
            Mi Ejecución Presupuestal del Mes en Curso
          </div>
          <div class="widget-content border-bottom themed-background-muted text-center">
            <bar-chart-asesor :grafica="'presupuesto_por_asesor'" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  name: "Dashboard",
  components: {
    PieChart: () => import("@/components/chart/PieChart"),
    BarChart: () => import("@/components/chart/BarChart"),
    BarChartAsesor: () => import("@/components/chart/BarChartAsesor")
  },
  data: () => {
    return {
      ocultar_info: false,
      iconClass: false,
      documento: "",
      datosConsulta: {
        loading: true
      },
      button_active_state: false,
      epi: [
        { key: "Sarah", value: 2502 },
        { key: "Emma", value: 2005 },
        { key: "Laura", value: 1968 },
        { key: "Chloé", value: 1863 },
        { key: "Marie", value: 1810 },
        { key: "Emily", value: 1637 }
      ],
      epg: [
        { key: "Sarah", value: 190 },
        { key: "Emma", value: 159 },
        { key: "Laura", value: 968 },
        { key: "Chloé", value: 183 },
        { key: "Marie", value: 180 },
        { key: "Emily", value: 137 }
      ],
      options: {
        circleBackground: "rgb(12,240,233)"
      }
    };
  },
  computed: {
    ...mapGetters({
      loading: "loading",
      external_pause: "vicidial/external_pause"
    })
  },
  methods: {
    consultar() {
      this.$router.push({ path: "/informacion-contacto/" + this.documento + "/documento" });
    },
    consultaAmpliada() {
      this.$router.push({ path: "/informacion-ampliada/" + this.documento });
    },
    externalPauseToggle() {
      this.$store.dispatch("vicidial/pausarReanudarAgente");
    }
  },
  mounted() {
    this.datosConsulta = {
      gestiones_mes: 0,
      gestiones_hoy: 0,
      acuerdos_mes: 0,
      acuerdos_hoy: 0,
      loading: false
    };

    this.ocultar_info = this.$store.getters['user/user'].ocultar_info;
    //
    // this.$store.commit("CLEAR_UUID");
    // this.$store
    //   .dispatch("gestion/datosAbonoGestion")
    //   .then(data => {
    //     this.datosConsulta = {
    //       gestiones_mes: data.gestiones_mes,
    //       gestiones_hoy: data.gestiones_hoy,
    //       acuerdos_mes: data.acuerdos_mes,
    //       acuerdos_hoy: data.acuerdos_hoy,
    //       loading: false
    //     };
    //   })
    //   .catch(error => {
    //     this.datosConsulta = {
    //       loading: false
    //     };
    //   });
  }
};
</script>
<style>
.centrado {
  display: flex;
  justify-content: center;
  /* center horizontally */
  align-items: center;
}
</style>
